import {applyMiddleware, combineReducers, createStore} from 'redux';
import thunk from 'redux-thunk';
import {reducer as formReducer} from 'redux-form'

import toastReducer from '../reducers/toast';
import empresaReducer from '../reducers/empresa';
import eventoReducer from '../reducers/evento';
import usuarioReducer from '../reducers/usuario';

export default function configureStore(initialState) {
    return createStore(
        combineReducers({
            form: formReducer,
            toast: toastReducer,
            empresas: empresaReducer,
            eventos: eventoReducer,
            usuarios: usuarioReducer
        }),
        initialState,
        applyMiddleware(thunk)
    );
}


// WEBPACK FOOTER //
// src/store/index.js